import React from 'react';
import { withRouter } from 'react-router-dom';
import { Button } from '@jutro/components';
import { MetadataContent } from '@jutro/uiconfig';
import { useTranslator } from '@jutro/locale';
import metadata from './AdacCallCenterPage.metadata.json5';
import messages from './AdacCallCenterPage.messages';
import styles from './AdacCallCenterPage.module.scss';

function CallCenterPage({ history }) {
    const translator = useTranslator();
    const CALL_CENTER_PHONE_NR = translator(messages.phoneNumber);
    
    const overrides = {
        callButton: {
            onClick: () => {
                history.push('/');
            }
        },
        info2: {
            content: translator(messages.pleaseCall, { phoneNumber: CALL_CENTER_PHONE_NR })
        },
        backButton: {
            onClick: () => {
                window.location.href = 'https://www.adac.de/';
            }
        }
    };

    const call = () => {
        window.location.href = `tel:${CALL_CENTER_PHONE_NR}`;
    };

    const CallBtn = () => (
        <Button onClick={call} icon="phone">
            {CALL_CENTER_PHONE_NR}
        </Button>
    );

    const resolvers = {
        resolveClassNameMap: styles,
        resolveComponentMap: {
            callbtn: CallBtn
        }
    };
    return <MetadataContent
        uiProps={metadata.pageContent}
        overrideProps={overrides}
        {...resolvers}
    />;
}

export default withRouter(CallCenterPage);
